import { f7 } from 'framework7-react';
import { useCallback, useMemo, useState } from 'react';
import { CheckInReserveDataType } from '../../../types/bodyAndPaint';
import { CheckInReserveConfirm } from './checkInReserve/checkInReserveConfirm';
import { CheckInReserveDialogCard } from './checkInReserve/checkInReserveDialogCard';
import { usePostRepairCheckInReserve } from './hook/api/usePostRepairCheckInReserve';
import { useCheckInReserveConfirmData } from './hook/useCheckInReserveConfirmData';
import { useStorageItem } from './hook/useStorageItem';
import { PageTemplateComponent } from './util/common/pageTemplate/pageTemplate';
import { DialogComponent } from './util/dialogFrame';
import { paths } from '@/config/paths';

export const CheckInReserveConfirmPage = () => {
  const { stored: checkInEntries, setStorageItem: setCheckInEntries } =
    useStorageItem<CheckInReserveDataType>({
      key: 'checkInReserve',
    });
  const [openReserveDialog, setOpenReserveDialog] = useState(false);
  const [approve, setApprove] = useState(false);
  const disabled = useMemo(() => !approve, [approve]);

  const { checkInReserveParams, checkInReserveLists } =
    useCheckInReserveConfirmData({ initial: checkInEntries });

  const { postRequest: checkInReserveRequest } = usePostRepairCheckInReserve({
    info: checkInReserveParams,
  });

  const handleClickBack = () => {
    f7.views.main.router.navigate(paths.bpsCheckInUseLoanerCar);
  };

  const handleClickEditCarCondition = useCallback(() => {
    f7.views.main.router.navigate(paths.bpsCheckInCarCondition);
  }, []);
  const handleClickEditLoanerCar = useCallback(() => {
    f7.views.main.router.navigate(paths.bpsCheckInUseLoanerCar);
  }, []);
  const handleClickEditCheckInDate = useCallback(() => {
    f7.views.main.router.navigate(paths.bpsCheckInReserveDate);
  }, []);

  const handleChangeApproveCheck = useCallback(() => {
    setApprove((prev) => !prev);
  }, []);
  const handleClickCheckInReserve = useCallback(() => {
    checkInReserveRequest().then(() => setOpenReserveDialog(true));
  }, [checkInReserveRequest]);
  const handleClickCloseDialog = useCallback(() => {
    setOpenReserveDialog(false);
    setCheckInEntries({
      carConditionInfo: {},
      insuranceInfo: {},
      checkInDateInfo: {},
      loanerCarInfo: {},
    } as CheckInReserveDataType);
    f7.views.main.router.navigate(paths.maintenance);
  }, []);

  return (
    <PageTemplateComponent
      pageName={'checkInReserve'}
      title={'予約確認'}
      onBack={handleClickBack}
    >
      <CheckInReserveConfirm
        listItem={checkInReserveLists}
        checkApprove={approve}
        disabled={disabled}
        onChangeApprove={handleChangeApproveCheck}
        onEditCarCondition={handleClickEditCarCondition}
        onEditLoanerCar={handleClickEditLoanerCar}
        onEditCheckInDate={handleClickEditCheckInDate}
        onReserve={handleClickCheckInReserve}
      />
      <DialogComponent open={openReserveDialog}>
        <CheckInReserveDialogCard onClick={handleClickCloseDialog} />
      </DialogComponent>
    </PageTemplateComponent>
  );
};
